module.exports = __webpack_public_path__ + "img/mmrm.e0e13722.png";